<t4-container title="{{ 'Turbo.Common.Reports.lblCreateReport' | translate : 'Create report' }}">
  <div class="row">
    <div class="col-3">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'turbo.core.report.lblReportDateFrom' | translate : 'Start date'}}</mat-label>
        <mat-icon matPrefix>date_range</mat-icon>
        <input matInput [matDatepicker]="pickupPicker" required [(ngModel)]="fromDate">
        <mat-datepicker-toggle matSuffix [for]="pickupPicker"></mat-datepicker-toggle>
        <mat-datepicker #pickupPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'turbo.core.report.lblReportDateTo' | translate : 'End date'}}</mat-label>
        <mat-icon matPrefix>date_range</mat-icon>
        <input matInput placeholder="{{ 'turbo.core.createScheduledReportDialog.lblDateTo' | translate : 'To'}}" [matDatepicker]="pickupPicker2" [(ngModel)]="toDate">
        <mat-datepicker-toggle matSuffix [for]="pickupPicker2"></mat-datepicker-toggle>
        <mat-datepicker #pickupPicker2></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'turbo.core.report.drpFormat' | translate : 'Format'}}</mat-label>
        <mat-select required [(ngModel)]="format" matNativeControl>
          <mat-option value="1">Excel</mat-option>
          <mat-option value="0" *ngIf="!isExcelOnly">Csv </mat-option>
          <mat-option value="2" *ngIf="!isExcelOnly">JSon</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-3">
      <button mat-raised-button (click)="runReport()" color="primary">{{ 'Turbo.Common.Reports.cmdCreateReport' | translate : 'Create report' }}</button>
    </div>
  </div>
</t4-container>

  <t4-container title="{{ 'Turbo.Common.Reports.lblCreatedReports' | translate : 'Created reports' }}">
    <t4-data-table #tblRuns [rawData]="runs" [autoGenerateColumns]="false" headline="" matSort>
      <ng-container matColumnDef="Id">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 50px;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 50px;">
          <mat-icon *ngIf="row.OrderedAt > time(-1)" style="color: orange">grade</mat-icon>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="OrderedAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100px;">{{ 'Turbo.Common.Reports.OrderedAt' | translate : 'Ordered at' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px;">{{ row.OrderedAt | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="RunTime">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100px;">{{ 'Turbo.Common.Reports.RunTime' | translate : 'Generated at' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px;">{{ row.RunTime | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="From">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100px;">{{ 'Turbo.Common.Reports.From' | translate : 'From' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px;">{{ row.From | date : 'yyyy-MM-dd' }}</mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="To">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100px;">{{ 'Turbo.Common.Reports.To' | translate : 'To' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px;">{{ row.To | date : 'yyyy-MM-dd' }}</mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Format">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100px;">{{ 'Turbo.Common.Reports.Format' | translate : 'Format' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 100px;">{{ 'Turbo.Common.Reports.Format_' + row.Format | translate : row.Format }}</mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Uri">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 50px;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 50px;">
          <mat-mini-fab *ngIf="row.RunTime" (click)="downloadReport(row.Uri)"><mat-icon>download</mat-icon></mat-mini-fab>
          <mat-progress-spinner *ngIf="!row.RunTime" mode="indeterminate" [diameter]="30"></mat-progress-spinner>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Warning">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 25px;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 25px;">
          <mat-mini-fab *ngIf="row.RunTime < row.To" matTooltip="{{ 'Turbo.Common.Reports.lblDataWarning' | translate : 'Report contains incomplete data.' }}" ><mat-icon style="color:#EED202">warning</mat-icon></mat-mini-fab>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
      </ng-container>

    </t4-data-table>
  </t4-container>
